import { RemoteData } from 'app/infrastructure/remote-data/remote-data';
import { endpoint } from 'app/area/case/endpoints';

export const api = {

  editCase: async (
    caseId: number, caseContextId: number = undefined, captchaToken?: string
  ): Promise<{ location: number, response: any }> => {
    const body: any = { caseId };
    if (caseContextId) { 
      body.caseContextId = caseContextId;
    }
    return await new RemoteData(endpoint.draft)
      .resource<any>()
      .withHeader('g-recaptcha-response', captchaToken)
      .filter({ includeDraftData: false })
      .create(body, true);
  }

};
